export default __webpack_public_path__ + "static/media/silent_drives.b8e3da33.png";